export { CTASpotlightBanner } from './CTASpotlightBanner';
export type { CTASpotlightBannerProps } from './types';
